import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { LanguageEnum } from 'server/shared/models/language.enum';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: LanguageSelectComponent,
      multi: true,
    },
  ],
})
export class LanguageSelectComponent implements OnInit {
  readonly languageEnum = LanguageEnum;

  isDisabled$ = new BehaviorSubject<boolean>(false);

  selectedValue$ = new BehaviorSubject<LanguageEnum | undefined>(undefined);

  @ContentChild('hint') hintContent?: TemplateRef<any>;

  onChange: any = (language: LanguageEnum) => {};
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onTouch: any = () => {};
  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  constructor() {}

  setDisabledState(isDisabled: boolean) {
    this.isDisabled$.next(isDisabled);
  }

  writeValue(value: LanguageEnum) {
    this.selectedValue$.next(value);
  }

  ngOnInit(): void {}

  selectionChanged(language: LanguageEnum) {
    this.selectedValue$.next(language);
    this.onChange(language);
  }
}
